import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useTheme } from '../hooks/useTheme.js';
import 'react';
import '../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import { Box } from '../Box/index.js';
import { HiddenVisually } from '../HiddenVisually/index.js';
import { ProgressCircleValue } from './ProgressCircleValue.js';
import { ProgressCircleGradient } from './ProgressCircleGradient.js';

var ProgressCircle = function (_a) {
    var children = _a.children, id = _a.id, _b = _a.labelColor, labelColor = _b === void 0 ? "black.100" : _b, _c = _a.showValue, showValue = _c === void 0 ? true : _c, _d = _a.size, size = _d === void 0 ? "lg" : _d, _e = _a.tone, tone = _e === void 0 ? "primary" : _e, _f = _a.value, value = _f === void 0 ? 0 : _f, sx = _a.sx, props = __rest(_a, ["children", "id", "labelColor", "showValue", "size", "tone", "value", "sx"]);
    var isValueOver = value > 100;
    var offsetValue = isValueOver ? 20 : value;
    var remainderVal = value % 100 || value;
    var autoId = useId();
    var gradientId = id ? id : "svg-gradient--".concat(autoId);
    var calcPercentageToDegrees = function () {
        var onePercent = 360 / 100;
        return (remainderVal - offsetValue) * onePercent;
    };
    var getBaseStyles = function () {
        var baseStyle = {
            color: "".concat(tone, ".60"),
            bg: "black.10",
        };
        if (isValueOver) {
            baseStyle.color = "".concat(tone, ".100");
            baseStyle.bg = "".concat(tone, ".60");
        }
        return __assign(__assign({}, baseStyle), sx);
    };
    var handleStyleProps = useTheme().handleStyleProps;
    var _g = handleStyleProps(__assign(__assign({ size: size }, props), { sx: getBaseStyles }), {
        themeKey: "progressCircle",
    }), css = _g.css, containerProps = __rest(_g, ["css"]);
    var colorCss = handleStyleProps({}, { baseStyle: { color: labelColor } }).css;
    var fontColor = colorCss.color;
    // extract color and backgroundColor and set vars
    var color = css.color, backgroundColor = css.backgroundColor, restCss = __rest(css, ["color", "backgroundColor"]);
    var containerCss = __assign(__assign({}, restCss), { color: fontColor });
    var progressCircleCss = {
        path: {
            stroke: isValueOver ? "url(#".concat(gradientId, ")") : color,
            strokeLinecap: "round",
            transform: isValueOver
                ? "rotate(".concat(calcPercentageToDegrees(), "deg)")
                : "none",
            transformOrigin: "center",
        },
        trail: { stroke: backgroundColor },
    };
    return (jsxs(Box, __assign({ css: containerCss }, containerProps, { children: [jsx(ProgressCircleGradient, { id: gradientId, toColor: color, fromColor: backgroundColor, isValueOver: isValueOver }), jsx(CircularProgressbar, { styles: progressCircleCss, value: offsetValue }), jsxs(Box, __assign({ sx: { flexDirection: "column" }, themeKey: "progressCircleValue" }, { children: [children, !children && showValue ? (jsx(ProgressCircleValue, { label: value })) : (jsx(HiddenVisually, { children: jsx(ProgressCircleValue, { label: value }) }))] }))] })));
};
ProgressCircle.displayName = "ProgressCircle";

export { ProgressCircle };
//# sourceMappingURL=ProgressCircle.js.map
